import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getAllArea = async (params: any) => {
  const url = endpoints.VIEW_LIST_AREA;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params: params,
  });

  return response;
};

const getAreaById = async (id: number) => {
  const url = endpoints.VIEW_LIST_AREA + "/" + id;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const createArea = async (params: any) => {
  const url = endpoints.VIEW_LIST_AREA;

  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const updateArea = async (params: any) => {
  const url = endpoints.VIEW_LIST_AREA + "/" + params.id;

  const { data: response } = await axios.put(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deleteArea = async (id: number) => {
  const url = endpoints.VIEW_LIST_AREA + "/" + id;

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const areaService = {
  getAllArea,
  createArea,
  updateArea,
  deleteArea,
  getAreaById,
};

export default areaService;
